import React, { useState } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getNodeByKey } from 'lexical';
import { Image } from '@chakra-ui/react';
import CloseModalIcon from '../../../assets/close-modal-icon.svg';
import type { NodeKey } from 'lexical';

type WithNodeKey = {
  nodeKey: NodeKey;
  isEmbed?: boolean;
  [key: string]: any;
};

export function withDeleteButton<T extends WithNodeKey>(WrappedComponent: React.ComponentType<T>) {
  return React.forwardRef<any, T>((props, ref) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isButtonHovered, setButtonHovered] = useState(false);
    const [editor] = useLexicalComposerContext();
    const onClickRemove = () => {
      editor.update(() => {
        const node = $getNodeByKey(props.nodeKey);
        if (node) {
          node.remove();
        }
      });
    };
    const buttonShadow = isButtonHovered
      ? '0 6px 12px rgba(0,0,0,0.25), 0 3px 6px rgba(0,0,0,0.15)'
      : '0 4px 8px rgba(0,0,0,0.2), 0 2px 4px rgba(0,0,0,0.1)';

    const imgStyles: React.CSSProperties = {
      width: '100%',
      height: '100%',
      pointerEvents: 'none'
    };
    const containerStyles: React.CSSProperties = props.isEmbed
      ? {
          position: 'relative',
          display: 'inline-block',
          width: '100%'
        }
      : {
          position: 'relative',
          display: 'inline-block'
        };

    return (
      <div
        style={containerStyles}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* @ts-ignore */}
        <WrappedComponent {...props} ref={ref} />
        {isHovered && !props.hideDeleteButton && (
          <button
            hidden={!editor.isEditable()}
            className="cursor-pointer"
            onMouseEnter={() => setButtonHovered(true)}
            onMouseLeave={() => setButtonHovered(false)}
            onClick={onClickRemove}
            style={{
              position: 'absolute',
              top: '-10px',
              right: '-10px',
              zIndex: 999999999999999,
              background: 'white',
              borderRadius: '50%',
              boxShadow: buttonShadow,
              border: 'none',
              transition: 'box-shadow 0.2s ease-in-out',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer !important',
              height: '25px',
              width: '25px'
            }}
            aria-label="Delete node"
          >
            <img src={CloseModalIcon} alt="" style={imgStyles} />
          </button>
        )}
      </div>
    );
  });
}
